module.exports = __webpack_public_path__ + "f7dfd384902cc3e24e5faa5d9a336164.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/prater-sans-two-bold.ttf
// module id = 31
// module chunks = 0